<template>
  <div class="become-vip">
    <Nav subNav="开通会员" :isShowBack="1"></Nav>
    <div class="become-vip-wrap">
      <div class="back-wrap" @click="backClick">
        <div class="back-icon"></div>
        返回
      </div>
      <div class="wrap2">
        <div class="user-wrap">
          <div
            class="avatar-wrap"
            :class="{
              'avatar-wrap2': this.$store.state.user.vip_left <= 0,
            }"
          >
            <img :src="this.$store.state.user.avatar" alt="#" />
            <div
              :class="{
                'vip-icon': this.$store.state.user.vip_left > 0,
                'member-icon': this.$store.state.user.vip_left <= 0,
              }"
            >
              {{
                this.$store.state.user.vip_left <= 0 ? "免费会员" : "VIP会员"
              }}
            </div>
          </div>
          <div
            :class="{
              'name-wrap': true,
              'name-wrap2': this.$store.state.user.vip_left <= 0,
            }"
          >
            <div class="text1">
              {{ this.$store.state.user.name }}
            </div>
            <div class="text2">ID:{{ this.$store.state.user.uid }}</div>
            <div class="vip-time" v-if="this.$store.state.user.vip_left > 0">
              有效日期至：{{ vipDate }}
            </div>
          </div>
        </div>
        <div class="vip-desc-wrap isvip">
          <div class="vip-desc-wrap-bg">
            <div class="title-wrap">
              <div class="title-text">会员权益</div>
              <div class="title-desc-vip">高级会员</div>
              <div class="title-desc">免费会员</div>
            </div>
            <div class="vip-desc-col vip-desc-col-01">
              <div class="vip-desc-item bind-item">
                <div class="vip-desc-icon"></div>
                <div class="vip-desc-key">绑定设备</div>
              </div>
              <div class="vip-desc-item-hr"></div>
              <div class="vip-desc-item times-item">
                <div class="vip-desc-icon"></div>
                <div class="vip-desc-key">传输速度</div>
              </div>
              <div class="vip-desc-item-hr"></div>
              <div class="vip-desc-item backup-item">
                <div class="vip-desc-icon"></div>
                <div class="vip-desc-key">相册备份</div>
              </div>
              <!-- <div class="vip-desc-item-hr"></div>
            <div class="vip-desc-item remote-item">
              <div class="vip-desc-icon"></div>
              <div class="vip-desc-key">远程打印</div>
            </div> -->
              <div class="vip-desc-item-hr"></div>
              <div class="vip-desc-item network-item">
                <div class="vip-desc-icon"></div>
                <div class="vip-desc-key">内网穿透</div>
              </div>
            </div>
            <div class="vip-desc-col vip-desc-col-02">
              <div class="vip-desc-item bind-item">
                <div class="vip-desc-value">
                  {{ $store.state.limit.bind.normal }}台
                </div>
              </div>
              <div class="vip-desc-item-hr"></div>
              <div class="vip-desc-item times-item">
                <div class="vip-desc-value">普通</div>
              </div>
              <div class="vip-desc-item-hr"></div>
              <div class="vip-desc-item times-item">
                <div class="vip-desc-value">不支持</div>
              </div>
              <!-- <div class="vip-desc-item-hr"></div>
            <div class="vip-desc-item speed-item">
              <div class="vip-desc-value">不支持</div>
            </div> -->
              <div class="vip-desc-item-hr"></div>
              <div class="vip-desc-item vip-item">
                <div class="vip-desc-value">不支持</div>
              </div>
            </div>
            <div class="vip-desc-col vip-desc-col-03">
              <div class="vip-desc-item bind-item">
                <div class="vip-desc-value vip-desc-value-right">6台</div>
              </div>
              <div class="vip-desc-item-hr"></div>
              <div class="vip-desc-item times-item">
                <div class="vip-desc-value vip-desc-value-right">高速</div>
              </div>
              <div class="vip-desc-item-hr"></div>
              <div class="vip-desc-item times-item">
                <div class="vip-desc-value vip-desc-value-right">支持</div>
              </div>
              <!-- <div class="vip-desc-item-hr"></div>
            <div class="vip-desc-item speed-item">
              <div class="vip-desc-value vip-desc-value-right">支持</div>
            </div> -->
              <div class="vip-desc-item-hr"></div>
              <div class="vip-desc-item vip-item">
                <div class="vip-desc-value vip-desc-value-right">支持</div>
              </div>
            </div>
          </div>
        </div>
        <div class="vip-desc" v-if="false">
          <div class="become-item2-a">
            <div class="a1">
              <div class="a-icon"></div>
              绑定设备&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div class="a-line"></div>
            <div class="a1">
              <div class="a-icon a-icon2"></div>
              传输速度&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div class="a-line"></div>
            <div class="a1">
              <div class="a-icon a-icon3"></div>
              相册备份&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div class="a-line"></div>
            <div class="a1">
              <div class="a-icon a-icon4"></div>
              远程打印&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div class="a-line"></div>
            <div class="a1">
              <div class="a-icon a-icon5"></div>
              内网穿透&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <div class="become-item2-a become-item2-b">
            <div class="a1">{{ $store.state.limit.bind.normal }}台</div>
            <div class="a-line"></div>
            <div class="a1">普通</div>
            <div class="a-line"></div>
            <div class="a1">不支持</div>
            <div class="a-line"></div>
            <div class="a1">不支持</div>
            <div class="a-line"></div>
            <div class="a1">不支持</div>
          </div>
          <div class="become-item2-a become-item2-c">
            <div class="a1">6台</div>
            <div class="a-line"></div>
            <div class="a1">高速</div>
            <div class="a-line"></div>
            <div class="a1">支持</div>
            <div class="a-line"></div>
            <div class="a1">支持</div>
            <div class="a-line"></div>
            <div class="a1">支持</div>
          </div>
        </div>
      </div>
      <div class="wrap1">
        <div class="goods-wrap">
          <div class="goods-item-title">请选择时长</div>
          <div class="goods-item-wrap">
            <div
              class="goods-item"
              :class="{
                'goods-item-active': checkGoods == index,
              }"
              @click="checkGoodsClick(item, index)"
              v-for="(item, index) in goodsList"
              :key="index"
            >
              <div class="text1">{{ item.gdesc }}个月</div>
              <div class="price-wrap">
                <div class="price" v-if="item.gsellprice != 990">
                  {{ item.gsellprice / 100 }}
                </div>
                <div class="price special-price" v-else>9 <span>.9</span></div>
              </div>
              <div class="month-price">
                <div class="promotion-price">{{ item.gprice / 100 }}元</div>
              </div>
              <div v-if="item.gsellprice == 990" class="new-user-text"></div>
            </div>
          </div>
          <div class="pay-wrap">
            <div class="qrcode">
              <canvas id="weixin"></canvas>
            </div>
            <div class="pay-info-wrap">
              <div class="pay-money-text">
                支付金额：
                <span class="text1" v-if="goodsItem.gsellprice != 990">{{
                  goodsItem.gsellprice / 100
                }}</span>
                <span class="text1 special-price" v-else
                  >9 <span>.9</span></span
                >
                <span class="text2">元</span>
                <span class="text3"
                  >（原价{{ goodsItem.gprice / 100 }}元）</span
                >
              </div>
              <div class="pay-way-title">支付方式：</div>
              <div
                class="pay-way-wrap"
                :class="{ 'pay-way-active': checkPayway == 2 }"
                @click="checkPaywayClick(2)"
              >
                <div class="wechat-icon"></div>
                微信扫码支付
              </div>
              <div class="pay-way-wrap pay-way-wrap3" v-if="false">
                小宝积分
              </div>
              <div
                class="pay-way-wrap"
                :class="{ 'pay-way-active': checkPayway == 1 }"
                v-if="false"
              >
                <div class="wechat-icon ali-icon"></div>
                支付宝扫码支付
              </div>
            </div>
            <div
              class="xy-btn"
              @click="openUrl('https://www.ionewu.com/JdxbUProtocol.html')"
            >
              开通前请阅读《节点小宝会员服务协议》
            </div>
          </div>
        </div>
      </div>
    </div>

    <BecomeVipMessage
      v-if="isShowMessage"
      :vipDate="vipDate"
      :messageType="messageType"
      @closeMessageClick="closeMessageClick"
    ></BecomeVipMessage>

    <PayExchange
      @onCloseClick="hidePayExchange"
      v-if="isShowExchange"
    ></PayExchange>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import BecomeVipMessage from "./BecomeVipMessage.vue";
import QRcode from "qrcode";
import Nav from "@/components/Common/Nav.vue";
import PayExchange from "@/components/user/PayExchange.vue";

export default {
  name: "BecomeVip",
  components: {
    BecomeVipMessage,
    Nav,
    PayExchange,
  },
  data: function () {
    return {
      checkGoods: 0,
      checkPayway: 2,
      isShowMessage: false,
      messageType: 1, //1支付成功
      goodsList: [],
      goodsItem: {},
      checkWeixinPayIntval: null,
      outTradeNO: "",
      vipDate: "",
      isShowExchange: false,
    };
  },
  watch: {
    "$store.state.user.vip_left": function () {
      this.renderVipDate();
    },
    goodsItem: function (val) {
      let _that = this;
      _that.myUnifiedOrder();
    },
  },
  methods: {
    ...mapActions([
      "goods",
      "unifiedOrder",
      "orderQuery",
      "vipLeft",
      "sendUserlog",
    ]),
    hidePayExchange: function () {
      this.isShowExchange = false;
    },
    backClick: function () {
      this.$router.back(-1);
    },
    openUrl: function (url) {
      let _that = this;
      _that.$common.bridge(_that.$store.state.client).openBrowser(url);
    },
    goHistoryClick: function () {
      let _that = this;
      _that.$router.go(-1);
    },
    renderVipDate: function () {
      let _that = this;
      let timestamp = new Date().getTime();
      timestamp += _that.$store.state.user.vip_left * 1000;
      _that.vipDate = new Date(timestamp).Format("yyyy-MM-dd");
    },
    checkGoodsClick: function (item, data) {
      let _that = this;
      _that.checkGoods = data;
      _that.goodsItem = item;
    },
    checkPaywayClick: function (data) {
      let _that = this;
      _that.checkPayway = data;
    },
    showMessageClick: function (data) {
      let _that = this;
      _that.isShowMessage = true;
      _that.messageType = data;
    },
    closeMessageClick: function () {
      let _that = this;
      _that.isShowMessage = false;
    },
    getVipLeft: function () {
      let _that = this;
      _that.vipLeft([function () {}]);
    },
    myUnifiedOrder: function () {
      let _that = this;
      _that.unifiedOrder([
        _that.goodsItem.gid,
        function (err, data) {
          if (data && data.rtn == 0) {
            if (data.data.CodeURL) {
              _that.outTradeNO = data.data.outTradeNO;

              let canvas = document.getElementById("weixin");
              QRcode.toCanvas(
                canvas,
                data.data.CodeURL,
                { width: 136, height: 136 },
                function (error) {
                  if (error) {
                    console.error(error);
                    return;
                  }

                  clearInterval(_that.checkWeixinPayIntval);

                  _that.checkWeixinPayIntval = setInterval(function () {
                    _that.orderQuery([
                      _that.outTradeNO,
                      function (err, data) {
                        if (data && data.rtn == 0) {
                          if (data.data.trade_state == "SUCCESS") {
                            _that.getVipLeft();

                            //显示支付成功弹框
                            _that.showMessageClick(1);

                            setTimeout(function () {
                              clearInterval(_that.checkWeixinPayIntval);
                            }, 1000);
                          }
                        }
                      },
                    ]);
                  }, 5000);
                }
              );
            }
          }
        },
      ]);
    },
  },
  computed: {},

  deactivated() {
    let _that = this;
    _that.checkGoods = 0;
    clearInterval(_that.checkWeixinPayIntval);
  },
  activated() {
    let _that = this;
    _that.renderVipDate();
    _that.goods([
      function (err, data) {
        if (data && data.rtn == 0) {
          _that.goodsList = data.data;
          _that.goodsItem = _that.goodsList[0];
        }
      },
    ]);

    _that.sendUserlog(["pv_vip", ""]);
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.become-vip {
  width: 100%;
  height: 100%;
  background-color: #f4f6f9;
  box-sizing: border-box;
  font-size: 12px;
  color: #666666;

  .vip-desc-wrap {
    position: relative;
    margin: 0 auto;
    margin-top: 20px;
    background-image: linear-gradient(
      177deg,
      #a686ff 8.43%,
      #bea7ff 24.99%,
      #d7afff 48.44%,
      #b9c8ff 100%
    );
    box-shadow: 0px 4px 16px rgba(158, 177, 197, 0.25);
    border-radius: 8px;
    width: 326px;
    padding-bottom: 10px;
    // padding: 16px;
    .vip-desc-wrap-bg {
      background-image: url(../assets/views/my/vip-bg.png);
      background-position: 15px -4px;
      background-size: 78px;
      background-repeat: no-repeat;
      // padding: 0px 0px 8px 8px;
      &::before {
        position: absolute;
        right: 28px;
        content: "";
        display: block;
        background-image: url(../assets/views/my/novip-desc-bg.png);
        background-repeat: no-repeat;
        // background-position: center right;
        width: 70px;
        height: 30px;
        // line-height: 28px;
      }
    }
    .title-wrap {
      // background-image: url(../../assets/views/my/novip-desc-bg.png);
      // background-repeat: no-repeat;
      // background-position: center right;
      // background-size: 80px 28px;
      // height: 36px;
      // line-height: 28px;
      padding-top: 13px;
      .title-text {
        display: inline-block;
        vertical-align: top;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        height: 28px;
        color: #fff;
        margin-top: 3px;
        margin-left: 10px;
      }
      .title-desc,
      .title-desc-vip {
        float: right;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        height: 28px;
        color: #fff;
        margin-right: 39px;
        margin-top: 3px;
      }
      .title-desc-vip {
        margin-right: 17px;
      }
    }
    .vip-desc-col {
      display: inline-block;
      vertical-align: top;
      background-color: rgba(255, 255, 255, 0.72);
      border-radius: 4px;
      margin-right: 4px;
      color: #5c5c5c;
      text-align: left;
    }
    .vip-desc-col-01 {
      width: 120px;
    }
    .vip-desc-col-03 {
      margin-right: 0;
    }
    .vip-desc-col-02,
    .vip-desc-col-03 {
      width: 91px;
    }
    .vip-desc-col-03 {
      margin-right: 0px;
    }
    .vip-desc-item-wrap {
      margin-top: 6px;
      padding: 10px 0;
    }
    .vip-desc-item-hr {
      height: 1px;
      background-color: #c7c0b7;
      margin: 0 16px;
      opacity: 0.5;
    }
    .vip-desc-item {
      height: 47px;
      line-height: 47px;
      .vip-desc-icon {
        display: inline-block;
        vertical-align: top;
        width: 28px;
        height: 28px;
        background-size: 100% 100%;
        margin-top: 8px;
        margin-left: 16px;
        margin-right: 5px;
      }
      .vip-desc-key {
        display: inline-block;
        vertical-align: top;
        font-weight: 400;
        font-size: 14px;
        background: var(
          --ziti,
          linear-gradient(179deg, #4435db 0%, #bb3df7 100%)
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .vip-desc-value {
        font-weight: 400;
        font-size: 14px;
        margin-left: 20px;
        line-height: 46px;
        background: var(
          --ziti,
          linear-gradient(179deg, #4435db 0%, #bb3df7 100%)
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .vip-desc-value-right {
        width: 95px;
      }
    }
    .bind-item {
      .vip-desc-icon {
        background-image: url(../assets/views/my/vip-desc-01.png);
      }
    }
    .service-item {
      .vip-desc-icon {
        background-image: url(../assets/views/my/vip-desc-02.png);
      }
    }
    .times-item {
      .vip-desc-icon {
        background-image: url(../assets/views/my/vip-desc-02.png);
      }
    }
    .remote-item {
      .vip-desc-icon {
        background-image: url(../assets/views/my/vip-desc-04.png);
      }
    }
    .vip-item {
      .vip-desc-icon {
        background-image: url(../assets/views/my/vip-desc-04.png);
      }
    }
    .backup-item {
      .vip-desc-icon {
        background-image: url(../assets/views/my/vip-desc-03.png);
      }
    }
    .network-item {
      .vip-desc-icon {
        background-image: url(../assets/views/my/vip-desc-05.png);
      }
    }
  }
  .vip-desc-wrap.isvip {
    // background-image: url(../../assets/views/my/vip-desc-bg.png);
    // background-size: 100% 100%;
    .title-wrap {
      margin: 0 8px;
    }
    .vip-desc-item-wrap {
      background-color: rgba(255, 255, 255, 0.86);
      border-radius: 4px;
      .vip-desc-icon {
        margin-left: 22px;
      }
      .vip-desc-value {
        margin-right: 0px;
        color: #5b3d15;
      }
      .vip-desc-get {
        width: 24px;
        height: 24px;
        background-image: url(../assets/views/my/vip-desc-get.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        float: right;
        margin-top: 15px;
        margin-right: 4px;
      }
    }
  }

  .vip-desc {
    background-image: url(../assets/becomevip/desc-bg.png);
    width: 326px;
    height: 285px;
    // height: 250px;
    background-size: 100% auto;
    background-position: top center;
    background-repeat: no-repeat;
    margin: 0 auto;
    margin-top: 10px;
    box-shadow: 0 0 4px #cccccc;
    font-size: 0;
    border-radius: 8px;
    margin-top: 8px;
    text-align: center;
    color: #4435db;
    .become-item2-a,
    .become-item2-b,
    .become-item2-c {
      display: inline-block;
      vertical-align: top;
      margin-top: 45px;
    }
    .become-item2-a {
      width: 118px;
      border-radius: 4px;
      .a1 {
        line-height: 46px;
        font-size: 14px;
        color: #4435db;
        .a-icon {
          display: inline-block;
          margin-right: 4px;
          margin-top: 11px;
          vertical-align: top;
          width: 24px;
          height: 24px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-image: url("../assets/userinfov2/vip-icon-01.png");
        }
        .a-icon2 {
          background-image: url("../assets/userinfov2/vip-icon-02.png");
        }
        .a-icon3 {
          background-image: url("../assets/userinfov2/vip-icon-03.png");
        }
        .a-icon4 {
          background-image: url("../assets/userinfov2/vip-icon-04.png");
        }
        .a-icon5 {
          background-image: url("../assets/userinfov2/vip-icon-05.png");
        }
      }
      .a-line {
        margin: 0 auto;
        margin-top: -1px;
        width: 177px;
        height: 1px;
        // background-color: rgba(199, 192, 183, 0.4);
      }
    }
    .become-item2-b,
    .become-item2-c {
      margin-left: 5px;
      width: 88px;
      .a-line {
        width: 144px;
      }
    }
    .become-item2-c {
      .a-line {
        width: 146px;
      }
    }
  }

  .become-vip-wrap {
    margin: 0 auto;
    width: 932px;
    height: 496px;
    border: 1px solid #c9d9e4;
    border-radius: 4px;
    background-color: #ffffff;
    text-align: center;
    .back-wrap {
      height: 48px;
      line-height: 48px;
      font-weight: 700;
      font-size: 14px;
      color: #1a1a1a;
      width: 100px;
      cursor: pointer;

      .back-icon {
        display: inline-block;
        margin-left: 24px;
        margin-top: 15px;
        margin-right: 4px;
        vertical-align: top;
        width: 17px;
        height: 17px;
        background-image: url(../assets/setting/back.svg);
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
  }

  .bg {
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .wrap1,
  .wrap2 {
    display: inline-block;
    vertical-align: top;
  }
  .wrap1 {
    position: relative;
    padding-top: 1px;
    width: 562px;
    height: 414px;
    margin-left: 12px;
    background-image: url("../assets/userinfo/vip9.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    .title {
      position: relative;
      padding-left: 40px;
      height: 31px;
      line-height: 31px;
      box-sizing: border-box;
      width: 100%;
      color: #5c3107;
      font-size: 14px;
      font-weight: 700;
      .bg();
      background-image: url("../assets/becomevip/vip1.png");
    }
    .title::before {
      position: absolute;
      top: 6px;
      left: 10px;
      content: "";
      width: 18px;
      height: 18px;
      .bg();
      background-image: url("../assets/common/close3.svg");
      cursor: pointer;
    }
    .line {
      margin-top: -1px;
      height: 1px;
      width: 610px;
      .bg();
      background-image: url("../assets/becomevip/vip3.svg");
    }
    .goods-wrap {
      margin-top: 15px;
      width: 100%;

      .goods-item-title {
        margin-left: 24px;
        font-weight: 700;
        font-size: 20px;
        line-height: 26px;
        color: #5d3208;
        text-align: left;
      }

      .goods-item-wrap {
        margin-top: 33px;
        text-align: center;
        .goods-item {
          position: relative;
          display: inline-block;
          padding-top: 1px;
          margin-left: 9px;
          margin-right: 9px;
          width: 160px;
          height: 122px;
          box-sizing: border-box;
          border-radius: 8px;
          cursor: pointer;
          vertical-align: top;
          border: 1px solid rgba(228, 228, 228, 1);
          background-image: linear-gradient(195deg, #f6f6f6 12%, #fcfcfc 80%);

          .text1 {
            margin-top: 12px;
            text-align: center;
            font-size: 14px;
            font-weight: 700;
          }

          .price-wrap {
            margin-top: 8px;
            text-align: center;
            .price {
              position: relative;
              display: inline-block;
              font-size: 27px;
              font-weight: 700;
              color: #4e4d4b;
              padding-left: 10px;
              padding-right: 2px;
            }
            .price::before {
              content: "¥";
              position: absolute;
              left: 0;
              top: 15px;
              font-size: 12px;
            }
            .special-price {
              padding-right: 18px;
              position: relative;
              span {
                position: absolute;
                bottom: -4px;
                right: 0;
                font-size: 28px;
                transform: scale(0.6);
              }
            }
          }
          .month-price {
            margin-top: 6px;
            text-align: center;
            font-size: 14px;
            font-weight: 700;

            .promotion-price {
              position: relative;
              display: inline-block;
              width: 54px;
              color: #908f96;
            }
            .promotion-price::before {
              content: "";
              position: absolute;
              left: 0;
              top: 50%;
              transform: translate(0, -50%);
              width: 54px;
              height: 1px;
              background-color: #3c3c40;
            }
          }

          .new-user-text {
            position: absolute;
            top: 34px;
            right: 24px;
            background-image: url("../assets/becomevip/vip12.svg");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            width: 51px;
            height: 15px;
          }
        }
        .goods-item1 {
          margin-left: 0;
        }
        .goods-item-active {
          color: #432d20;
          background-image: linear-gradient(
            115deg,
            #fdf2e1 25%,
            #fcf0db 49%,
            #fbe9cb 86%
          );
          border: 1px solid #fac06f;
          box-shadow: 0px 6px 16px rgba(147, 141, 113, 0.2);
          .price-wrap {
            .price {
              color: #95682e;
            }
          }
          .text1 {
            color: #b68648;
          }
        }
      }
    }

    .pay-title {
      font-size: 14px;
      color: #5c3107;
      margin-top: 25px;
      margin-bottom: 15px;
      margin-left: 20px;
    }
    .pay-wrap {
      margin-top: 22px;
      padding-left: 50px;
      box-sizing: border-box;

      .qrcode,
      .pay-info-wrap {
        display: inline-block;
        vertical-align: top;
      }
      .qrcode {
        border: 2px solid #dddfe2;
        box-shadow: 0px 4px 12px rgba(192, 196, 206, 0.4);
        border-radius: 2px;
      }
      .pay-info-wrap {
        margin-left: 28px;
        .pay-money-text {
          text-align: left;
          color: #432d20;
          font-size: 14px;

          .text1 {
            font-size: 41px;
            font-weight: 700;
            color: #e81818;
          }
          .text2 {
            color: #e81818;
            font-size: 12px;
          }
          .text3 {
            color: #908f96;
            font-size: 12px;
          }
          .special-price {
            position: relative;
            padding-right: 10px;
            span {
              position: absolute;
              bottom: -5px;
              left: 15px;
              font-size: 41px;
              transform: scale(0.6);
            }
          }
        }
        .pay-way-title {
          margin-top: 4px;
          font-size: 14px;
          line-height: 18px;
          color: #1a1a1a;
          text-align: left;
        }
        .pay-way-wrap {
          margin-top: 8px;
          position: relative;
          display: inline-block;
          width: 148px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          box-sizing: border-box;
          border-radius: 3px;
          cursor: pointer;
          border: 1px solid transparent;
          .wechat-icon {
            display: inline-block;
            margin-right: 8px;
            margin-top: 12px;
            vertical-align: top;
            width: 24px;
            height: 24px;
            background-image: url("../assets/becomevip/vip6.svg");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
          .ali-icon {
            background-image: url("../assets/becomevip/vip7.svg");
          }
        }

        .pay-way-wrap3::before {
          background-image: url("../assets/becomevip/vip8.svg");
        }
        .pay-way-wrap3::after {
          content: "即将开通";
          padding: 1px 2px;
          position: absolute;
          top: -8px;
          right: -2px;
          width: 54px;
          height: 17px;
          line-height: 17px;
          border-radius: 10px 10px 10px 2px;
          background-color: #e81818;
          color: #ffebeb;
        }

        .pay-way-active {
          background-color: #fff8ef;
          border: 1px solid #e2b591;
        }
      }
      .xy-btn {
        position: absolute;
        left: 1px;
        bottom: 1px;
        width: 560px;
        height: 28px;
        line-height: 28px;
        background-color: #fff9ef;
        font-size: 12px;
        color: #666666;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .wrap2 {
    padding-top: 1px;
    width: 326px;
    height: 414px;
    border-radius: 5px;
    .bg();

    box-sizing: border-box;

    .user-wrap {
      padding-top: 22px;
      padding-top: 36px;
      padding-bottom: 22px;
      padding-bottom: 36px;
      text-align: center;
      background-color: #fff9ef;
      border-radius: 8px;
      box-shadow: 0 0 2px #cccccc;

      .avatar-wrap {
        position: relative;
        display: inline-block;
        width: 73px;
        height: 73px;
        border-radius: 50%;
        .bg();
        padding-top: 1px;
        box-sizing: border-box;
        background-color: #ebb63e;

        img {
          width: 71px;
          height: 71px;
          border-radius: 50%;
        }
        .member-icon,
        .vip-icon {
          position: absolute;
          padding-left: 30px;
          padding-top: 1px;
          left: -2px;
          top: 59px;
          width: 82px;
          height: 28px;
          line-height: 28px;
          box-sizing: border-box;
          text-align: left;
          .bg();
          background-image: url("../assets/userinfo/userinfo6.png");
        }
        .member-icon {
          padding-left: 28px;
        }
        .vip-icon {
          background-image: url("../assets/userinfo/userinfo7.png");
        }
      }
      .avatar-wrap2 {
        background-color: #a2abc0;
      }

      .name-wrap {
        display: inline-block;
        margin-top: 3px;
        vertical-align: top;
        text-align: left;
        margin-left: 16px;
        .text1 {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          color: #432d20;
          font-weight: 700;
          font-size: 15px;
          max-width: 120px;
        }
        .text2 {
          margin-top: 8px;
        }
        .vip-time {
          margin-top: 4px;
          font-size: 12px;
          line-height: 16px;
          color: rgba(67, 45, 32, 0.8);
        }
      }
      .name-wrap2 {
        margin-top: 10px;
      }

      .no-limit {
        padding-top: 44px;
        text-align: center;

        .vip-title-icon {
          margin: 0 auto;
          width: 121px;
          height: 25px;
          background-image: url("../assets/userinfo/vip7.svg");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .vip-title-icon2 {
          margin: 0 auto;
          margin-top: 4px;
          width: 302px;
          height: 28px;
          background-image: url("../assets/userinfo/vip8.svg");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .text1,
        .text2 {
          color: #635147;
          font-size: 15px;
          display: inline-block;
          font-weight: 900;
        }
        .text2 {
          position: relative;
          margin-left: 32px;
        }
        .text2::before {
          position: absolute;
          content: "";
          top: 50%;
          transform: translate(0, -50%);
          left: -30px;
          width: 27px;
          height: 27px;
          .bg();
          background-image: url("../assets/userinfo/d2.png");
        }
        .text-wrap {
          margin-top: 6px;
          background-image: url("../assets/becomevip/right_line.svg");
          background-repeat: no-repeat;
          background-size: 100% auto;
          background-position: center center;
          .text3 {
            margin-right: 2px;
          }
          .text3,
          .text4 {
            display: inline-block;
            color: #635147;
            font-size: 17px;
            font-weight: 900;
            letter-spacing: 1px;
          }
          .text4 {
            position: relative;
            padding-left: 14px;
          }
          .text4::before {
            position: absolute;
            left: 0;
            top: -3px;
            content: "8";
            font-size: 20px;
          }
        }
        .vip-item-wrap {
          position: relative;
          margin: 0 auto;
          margin-top: 16px;
          font-size: 0px;
          width: 302px;
          height: 188px;
          background: rgba(255, 249, 239, 0.5);
          box-shadow: inset 1px 1px 0px rgba(255, 255, 255, 0.5);
          border-radius: 4px;
          .vip-item {
            display: inline-block;
            vertical-align: top;
            text-align: center;
            width: 50%;

            .vip-item-title {
              line-height: 28px;
              font-size: 16px;
              color: #1a1a1a;
            }
            .icon {
              margin: 0 auto;
              margin-top: 2px;
              width: 36px;
              height: 36px;
              .bg();
            }
            .value_wrap {
              margin-top: 12px;
              text-align: center;
            }
            .vip-item-value {
              display: inline-block;
              margin-left: 5px;
              vertical-align: top;
              font-weight: 700;
              height: 18px;
              line-height: 18px;
              font-size: 14px;
              color: #763c10;
            }
            .icon2 {
              display: inline-block;
              vertical-align: top;
              width: 16px;
              height: 16px;
              .bg();
              background-image: url("../assets/userinfo/vip5.svg");
            }
            .text {
              display: inline-block;
              margin-right: 5px;
              vertical-align: top;
              font-size: 14px;
              line-height: 18px;
              color: rgba(103, 81, 66, 0.9);
            }

            .vip-item-01 {
              margin-top: 20px;
              margin-left: 20px;
              padding-right: 15px;
              padding-bottom: 12px;
              border-right: 1px solid rgba(210, 197, 184, 0.5);
              border-bottom: 1px solid rgba(210, 197, 184, 0.5);
              .icon {
                background-image: url("../assets/userinfo/vip_item_icon_06.svg");
              }
              .title-icon {
                display: inline-block;
                margin-right: 10px;
                vertical-align: top;
                width: 28px;
                height: 28px;
                background-image: url("../assets/userinfo/vip1.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                box-shadow: 0px 1px 2px rgba(196, 189, 182, 0.2);
              }
            }
            .vip-item-02 {
              margin-top: 20px;
              margin-right: 20px;
              padding-bottom: 12px;
              padding-left: 15px;
              border-bottom: 1px solid rgba(210, 197, 184, 0.5);

              .icon {
                background-image: url("../assets/userinfo/vip_item_icon_02.svg");
              }
              .title-icon {
                display: inline-block;
                margin-right: 5px;
                vertical-align: top;
                width: 28px;
                height: 28px;
                background-image: url("../assets/userinfo/vip2.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                box-shadow: 0px 1px 2px rgba(196, 189, 182, 0.2);
              }
            }
            .vip-item-03 {
              padding-top: 20px;
              padding-bottom: 12px;
              padding-right: 15px;
              margin-left: 21px;
              border-right: 1px solid rgba(210, 197, 184, 0.5);

              .icon {
                background-image: url("../assets/userinfo/vip_item_icon_05.svg");
              }
              .title-icon {
                display: inline-block;
                margin-right: 10px;
                vertical-align: top;
                width: 28px;
                height: 28px;
                background-image: url("../assets/userinfo/vip10.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                box-shadow: 0px 1px 2px rgba(196, 189, 182, 0.2);
              }
            }
            .vip-item-04 {
              padding-top: 20px;
              padding-bottom: 12px;
              padding-left: 0px;

              .icon {
                background-image: url("../assets/userinfo/vip_item_icon_03.svg");
              }
              .title-icon {
                display: inline-block;
                margin-right: 5px;
                vertical-align: top;
                width: 28px;
                height: 28px;
                background-image: url("../assets/userinfo/vip12.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                box-shadow: 0px 1px 2px rgba(196, 189, 182, 0.2);
              }
            }
            .vip-item-05 {
              padding-top: 10px;
              margin-left: 21px;
              border-right: 1px dashed #e2caad;
              border-top: 1px dashed #e2caad;

              .icon {
                background-image: url("../assets/userinfo/vip_item_icon_01.svg");
              }
            }
            .vip-item-06 {
              padding-top: 10px;
              margin-right: 21px;
              border-top: 1px dashed #e2caad;

              .icon {
                background-image: url("../assets/userinfo/vip_item_icon_04.svg");
              }
            }
          }
        }
        .vip-item-wrap::before {
          position: absolute;
          left: 50%;
          top: -12px;
          transform: translate(-50%, 0);
          content: "";
          width: 36px;
          height: 36px;
          background-image: url("../assets/userinfo/vip6.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
